var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlagNzIcon = function SvgFlagNzIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "flagNZIcon_svg__a",
    width: 16,
    height: 12,
    x: 0,
    y: 2,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 2h16v12H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#flagNZIcon_svg__a)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E42A5",
    fillRule: "evenodd",
    d: "M0 2v12h16V2z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "flagNZIcon_svg__b",
    width: 16,
    height: 12,
    x: 0,
    y: 2,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 2v12h16V2z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#flagNZIcon_svg__b)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B409A",
    d: "M0 2h9v7H0z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "flagNZIcon_svg__c",
    width: 9,
    height: 7,
    x: 0,
    y: 2,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 2h9v7H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#flagNZIcon_svg__c)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7FCFF",
    d: "m-1.002 8.5 1.98.868 8.067-6.424 1.044-1.29-2.117-.29-3.29 2.768-2.649 1.865z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F50100",
    d: "m-.731 9.108 1.009.505 9.436-8.08H8.298z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7FCFF",
    d: "m10.002 8.5-1.98.868-8.067-6.424-1.045-1.29 2.118-.29 3.29 2.768 2.649 1.865z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F50100",
    d: "m9.934 8.937-1.008.504-4.019-3.46-1.19-.386-4.907-3.937H.227L5.13 5.502l1.302.463z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F50100",
    fillRule: "evenodd",
    d: "M4.992 2h-1v3H0v1h3.992v3h1V6H9V5H4.992z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "flagNZIcon_svg__d",
    width: 11,
    height: 9,
    x: -1,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1 1h11v9H-1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M4.992 2h-1v3H0v1h3.992v3h1V6H9V5H4.992z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#flagNZIcon_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7FCFF",
    d: "M3.992 2v-.75h-.75V2zm1 0h.75v-.75h-.75zm-1 3v.75h.75V5zM0 5v-.75h-.75V5zm0 1h-.75v.75H0zm3.992 0h.75v-.75h-.75zm0 3h-.75v.75h.75zm1 0v.75h.75V9zm0-3v-.75h-.75V6zM9 6v.75h.75V6zm0-1h.75v-.75H9zM4.992 5h-.75v.75h.75zm-1-2.25h1v-1.5h-1zM4.742 5V2h-1.5v3zM0 5.75h3.992v-1.5H0zM.75 6V5h-1.5v1zm3.242-.75H0v1.5h3.992zM4.742 9V6h-1.5v3zm.25-.75h-1v1.5h1zM4.242 6v3h1.5V6zM9 5.25H4.992v1.5H9zM8.25 5v1h1.5V5zm-3.258.75H9v-1.5H4.992zM4.242 2v3h1.5V2z"
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#F50100",
    fillRule: "evenodd",
    d: "m12.05 5.735-.13.757.68-.357.68.357-.13-.757.55-.536-.76-.11-.34-.69-.34.69-.76.11zm-2 2.8-.13.757.68-.357.68.357-.13-.757L11.7 8l-.76-.11-.34-.69-.34.69L9.5 8zm1.663 3.197-.168.981.882-.463.881.463-.168-.981.713-.696-.986-.143-.44-.893-.441.893-.986.143zM13.42 9.29l.13-.756-.55-.536.76-.11.339-.688.34.688.758.11-.549.536.13.756-.68-.357z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7FCFF",
    d: "m11.92 6.492-.098-.017-.035.2.18-.094zm.13-.757.098.017.01-.052-.038-.036zm.55.4.046-.089-.046-.024-.047.024zm.68.357-.047.089.18.094-.035-.2zm-.13-.757-.07-.071-.037.036.008.052zm.55-.536.07.072.145-.142-.2-.029-.015.1Zm-.76-.11-.09.044.024.047.051.008zM12.6 4.4l.09-.044-.09-.182-.09.182zm-.34.689.014.099.053-.008.023-.047zm-.76.11-.014-.099-.2.03.144.14.07-.07ZM9.92 9.292l-.098-.017-.035.2.18-.094zm.13-.757.098.017.01-.052-.038-.036zm.55.4.046-.089-.046-.024-.047.024zm.68.357-.047.089.18.094-.035-.2zm-.13-.757-.07-.071-.037.036.008.052zM11.7 8l.07.072.145-.142-.2-.029zm-.76-.11-.09.044.024.047.051.008.015-.1Zm-.34-.69.09-.044-.09-.182-.09.182zm-.34.689.014.099.053-.008.023-.047zm-.76.11L9.486 7.9l-.2.03.144.14L9.5 8Zm2.045 4.715-.099-.017-.034.2.18-.095zm.168-.982.099.017.009-.052-.038-.037zm.714.518.046-.088-.046-.025-.047.024.047.09Zm.881.464-.046.088.18.094-.035-.2zm-.168-.982-.07-.072-.038.037.01.052zm.713-.695.07.071.145-.141-.2-.03zm-.986-.144-.09.044.024.048.052.007zm-.44-.893.09-.044-.09-.182-.09.182zm-.441.893.014.1.052-.008.023-.047-.09-.045Zm-.986.143-.014-.098-.2.029.144.141zm2.55-2.502.098.017.009-.052-.038-.037-.07.072Zm-.13.756-.099-.017-.034.2.18-.094zM13 7.998l-.014-.099-.2.03.144.141zm.76-.11.014.099.052-.008.023-.047-.09-.044Zm.339-.688.09-.044-.09-.182-.09.182zm.34.688-.09.044.023.047.052.008.014-.099Zm.758.11.07.072.145-.142-.2-.029-.014.1Zm-.549.536-.07-.072-.037.037.009.052zm.13.756-.047.089.18.094-.035-.2zm-.68-.357.047-.088-.046-.025-.047.024.047.089Zm-2.08-2.424.13-.757-.197-.034-.13.757.198.034Zm.535-.463-.68.358.094.177.68-.358zm.773.358-.68-.358-.093.177.68.358zm-.275-.652.13.757.197-.034-.13-.757zm.58-.624-.55.536.139.143.55-.536-.14-.143Zm-.706.06.76.11.03-.198-.76-.11zm-.415-.744.34.689.18-.088-.34-.69-.18.09Zm-.16.689.34-.689-.18-.088-.34.689zm-.836.165.76-.11-.028-.198-.76.11zm.606.366-.55-.536-.14.143.55.536zm-2.101 3.645.13-.757-.198-.034-.13.757zm.534-.463-.68.358.094.177.68-.358zm.773.358-.68-.358-.093.177.68.358zm-.275-.652.13.757.197-.034-.13-.757zm.58-.624-.55.536.139.143.55-.536zm-.706.06.76.11.03-.198-.76-.11zm-.415-.744.34.689.18-.088-.34-.69-.18.09Zm-.16.689.34-.689-.18-.088-.34.689zm-.836.165.76-.11-.028-.198-.76.11zm.606.366-.55-.536-.14.143.55.536zm1.523 4.266.169-.981-.197-.034-.169.982.197.034Zm.737-.569-.882.464.093.177.882-.463zm.975.464-.882-.463-.093.177.882.463zm-.314-.876.169.981.197-.033-.169-.982zm.742-.784-.713.695.14.143.713-.695zm-.93.027.986.143.028-.197-.985-.144zm-.516-.948.44.893.18-.088-.44-.893zm-.262.893.441-.893-.18-.088-.44.893.18.088Zm-1.06.199.985-.144-.029-.198-.985.144zm.768.524-.713-.695-.14.143.713.695zm1.668-3.143-.13.756.197.034.13-.756zm-.52-.447.549.535.14-.143-.55-.535zm.814-.281-.76.11.03.198.759-.11zm.264-.633-.34.688.18.088.34-.688zm.519.688-.34-.688-.179.088.34.688zm.684.055-.76-.11-.028.198.76.11zm-.494.706.55-.535-.14-.143-.55.535zm.158.668-.13-.756-.196.034.13.756zm-.824-.251.68.357.092-.178-.679-.357zm-.586.357.68-.357-.094-.178-.679.357z"
  })))));
};
export { SvgFlagNzIcon as ReactComponent };